<template>
    <div>
        <tq-tabs :p_vertical-layout_b="true"
                 p_tabs-class_s="TQ_padding_8px_16px"
                 class="TQ_bg_white TQ_margin_4px"

                 :p_selected-tab-index_vn="p_selectedGroupIndex_vn"
                 p_att_s="qbma_name_s"
                 :p_system_lang-code_e="co_displayLang_e"
                 :p_tabs_ao="p_questBody_c.qb_missionsArrangements_ac"
                 :p_title_blc_s="ass_strings.oneWord_missions"

                 :p_add-tab-text_s="ass_strings.twoWords_newArrangement[co_displayLang_e]"
                 :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteMission"

                 :pe_delete-tab_click_f="m_deleteMissionsArrangement_f"
                 :pe_add-tab_click_f="m_addNewArrangement_f">

            <div :key="p_selectedGroupIndex_vn.val" v-if="co_currentMissionArrangement_c" class="TQ_center TQ_padding_16px">

                <!-- name -->
                <div class="TQ_maxWidth_200px TQ_margin_bottom_16px TQ_center">
                    <div class="TQ_text_24px TQ_text_bold TQ_align_initial">
                        {{ass_strings.oneWord_name[co_displayLang_e]}}
                    </div>
                    <tq-textarea
                            :pb_uid_s="'str_' + p_selectedGroupIndex_vn.val"
                            pb_textarea-class_s="TQ_text_16px TQ_box_shadow TQ_padding_8px"
                            :pb_init-text_s="co_currentMissionArrangement_c.qbma_name_s"
                            :pb_max-length_n="20"
                            :pb_rows_n="1"
                            :pe_change-text_s="(text_s) => {co_currentMissionArrangement_c.qbma_name_s = text_s}"
                    />
                </div>

                <!-- mapMissionsGroup -->
                <div v-if="co_showPolygonsMapArrangement_b" class="TQ_maxWidth_450px TQ_inline">

                    <div class="TQ_text_24px TQ_text_bold TQ_align_initial">
                        {{ass_strings.threeWords_mapMissionsGroups[co_displayLang_e]}}
                    </div>

                    <draggable v-model="co_currentMissionArrangement_c.qbma_groupsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.MAP_MISSIONS]">

                        <div v-for="(qbma_groupsIndexes_n,index_n) in co_currentMissionArrangement_c.qbma_groupsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.MAP_MISSIONS]"
                             class="">
                            <div class="TQ_padding_8px TQ_border TQ_margin_8px TQ_bg_gray4 TQ_clickable TQ_maxWidth_200px ">
                                {{p_questBody_c.qb_mapMissionsGroup_ac[qbma_groupsIndexes_n].qbmg_name_byLangCode_s[co_displayLang_e]}}
                            </div>

                            <!--<div class="TQ_inline" @click="co_currentMissionArrangement_c.qbma_groupsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.MAP_MISSIONS].splice(index_n,1)">-->
                            <!--delete-->
                        <!--</div>-->

                        </div>

                    </draggable>

                </div>

                <!-- cards missions -->
                <div v-if="co_showArrangement_cardsMissions_b" class="TQ_maxWidth_450px TQ_inline TQ_width_100p TQ_margin_8px">

                    <div class="TQ_text_24px TQ_text_bold TQ_bg_purple_lite TQ_padding_8px">
                        {{ass_strings.twoWords_mapMissions[co_displayLang_e]}}
                    </div>


                    <draggable class="TQ_bg_gray4 TQ_padding_4px " v-model="co_currentMissionArrangement_c.qbma_missionsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.CARDS_MISSIONS]">

                        <div class="TQ_margin_8px" v-for="(missionIndexes_n, index_n) in co_currentMissionArrangement_c.qbma_missionsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.CARDS_MISSIONS]">
                            <div class="TQ_padding_8px TQ_border TQ_bg_white TQ_clickable TQ_maxWidth_200px TQ_center">
                                {{p_questBody_c.qb_cardsMissions_ac[missionIndexes_n] ? p_questBody_c.qb_cardsMissions_ac[missionIndexes_n].qbr_title_blc_s[co_displayLang_e] : missionIndexes_n }}
                            </div>
                            <!--<div class="TQ_inline" @click="co_currentMissionArrangement_c.qbma_missionsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.CARDS_MISSIONS].splice(index_n,1)">-->
                                <!--delete-->
                            <!--</div>-->
                        </div>

                    </draggable>
                </div>

            </div>

        </tq-tabs>
    </div>
</template>

<script>
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_langCodes,
        enum_mapMissionsTypes,
        enum_subCollection_teamStatus
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqTabs from "../../../../components/basic/TqTabs";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqTextarea from "../../../../components/basic/TqTextarea";
    import draggable from 'vuedraggable'
    import {notification_notify} from "../../../../scripts/S_Notification";
    import {
        FB_QuestBody,
        FB_QuestBody_MissionsArrangement
    } from "../../../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "c_Creator_EditQuests_Item_OrdersMissions",
        components: {TqTextarea, TqTabs, draggable},
        props:{
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_questBody_c :{
                type : FB_QuestBody,
                require: true
            },

        },
        data(){
            return {
                p_selectedGroupIndex_vn : {val : 0},
                ass_strings : ass_strings,

                enum_subCollection_teamStatus : enum_subCollection_teamStatus,
            }
        },
        computed : {
            co_currentMissionArrangement_c(){

                // arrange current group missions to % 3
                // this.p_questBody_c.qb_missionsArrangements_ac[this.p_selectedGroupIndex_vn.val]
                //     .qbma_missionsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.CARDS_MISSIONS] = this.p_questBody_c.qb_cardsMissions_ac.map((item, index) => {return index})
                //     .filter(index_n => {
                //
                //         return index_n % 3 === this.p_selectedGroupIndex_vn.val
                //     })

                return this.p_questBody_c.qb_missionsArrangements_ac[this.p_selectedGroupIndex_vn.val]
            },
            co_displayLang_e(){
                return this.p_questBody_c.cm_qb_getDisplayLangCode_e(this.p_system_langCode_e)
            },
            co_showPolygonsMapArrangement_b(){
                return this.p_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b
                    && this.p_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons_area
            },
            co_showArrangement_cardsMissions_b(){
                return this.p_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b
            },
        },
        methods:{
            m_addNewArrangement_f(){

                let groupsIndexes_byMissionCollection_an = {}
                let missionsIndexes_byMissionCollection_an = {}

                // polygons map
                if(this.co_showPolygonsMapArrangement_b){
                    groupsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.MAP_MISSIONS] = this.p_questBody_c.qb_mapMissionsGroup_ac.map((mapMissionGroup_c,index_n) => index_n)
                }

                // cards missions
                if(this.co_showArrangement_cardsMissions_b){
                    missionsIndexes_byMissionCollection_an[enum_subCollection_teamStatus.CARDS_MISSIONS] = this.p_questBody_c.qb_cardsMissions_ac.map((mapMissionGroup_c,index_n) => index_n)
                }

                // add all
                this.p_questBody_c.qb_missionsArrangements_ac.push(
                    new FB_QuestBody_MissionsArrangement({
                        qbma_name_s                                     :  ass_strings.twoWords_newArrangement[this.co_displayLang_e],
                        qbma_groupsIndexes_byMissionCollection_an       : groupsIndexes_byMissionCollection_an,
                        qbma_missionsIndexes_byMissionCollection_an     : missionsIndexes_byMissionCollection_an
                    })
                )
            },
            m_deleteMissionsArrangement_f(index_n){

                if(this.p_questBody_c.qb_missionsArrangements_ac.length > 1){
                    this.p_questBody_c.qb_missionsArrangements_ac.splice(index_n,1)
                }else{
                    notification_notify(ass_strings.oneWord_error)
                }
            }
        },
    }
</script>

<style scoped>

</style>